import { Component, OnDestroy, inject, input, output } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDialogService } from '@spartan-ng/helm/dialog';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { provideIcons } from '@ng-icons/core';
import { lucideTrash } from '@ng-icons/lucide';
import { Subscription, tap } from 'rxjs';
import { DeleteConfirmationDialogComponent } from '../delete-confirmation-dialog/delete-confirmation-dialog.component';

@Component({
  selector: 'app-delete-button-with-confirmation',
  template: `
    <div>
      <button hlmBtn variant="ghost" size="icon" class="text-destructive hover:text-destructive" (click)="openConfirmationDialog()" [title]="tooltipText()">
        <ng-icon name="lucideTrash" size="sm" hlm />
      </button>
    </div>
  `,
  imports: [...HlmButtonImports, ...HlmIconImports],
  providers: [provideIcons({ lucideTrash })],
})
export class DeleteButtonWithConfirmationComponent implements OnDestroy {
  private dialog = inject(HlmDialogService);

  readonly message = input.required<string>();
  readonly tooltipText = input.required<string>();
  readonly canDelete = output<boolean>();

  subscription: Subscription = new Subscription();

  openConfirmationDialog() {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      context: { message: this.message() },
    });
    
    this.subscription.add(
      dialogRef.closed$
        .pipe(tap((resp: any) => this.canDelete.emit(resp)))
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
